export default "__VITE_ASSET__Ch_uBnv$__"